import type { ProductSelection } from '@/components/products/CheckoutHandlerContext';

import { CompletionVariant } from '../types';

/**
 * Whether what was bought was for one habitat — a single-habitat day pass, or a sponsorship.
 *
 * Read off the selection rather than the product, because both are generic products: the habitat
 * they unlock is attached to the checkout, not to the catalogue entry. A pass that covers every
 * habitat carries no habitat ids at all, which is exactly the distinction wanted here.
 */
export const isForOneHabitat = (productChoice?: ProductSelection) => productChoice?.associatedHabitatIds?.length === 1;

/**
 * Which Completion Step to show.
 *
 * Two independent questions: did money change hands, and does the visitor have a persona. The
 * persona half is uniform across every flow — whoever would otherwise finish without one is asked
 * here, because there is no other moment left to ask.
 *
 * `partner-welcome` is not produced here: it is decided at resolve time from the inbound link,
 * before any flow runs.
 */
const completionVariantFor = ({ purchased, hasPersona }: { purchased: boolean; hasPersona: boolean }): CompletionVariant => {
  if (purchased) {
    return hasPersona ? 'purchase' : 'purchase-with-persona';
  }
  return hasPersona ? 'account' : 'account-with-persona';
};

export default completionVariantFor;
